import Vue from "vue";
// import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import {
  BootstrapVueIcons,
  BVConfigPlugin,
  BContainer,
  BRow,
  BCol,
  BButton,
  BCard,
  BCardTitle,
  BCardBody,
  BCardText,
  BCardFooter,
  BCardImg,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckboxGroup,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BFormSelect,
  BFormTextarea,
  BFormInvalidFeedback,
  BFormSelectOption,
  BDropdown,
  BDropdownItem,
  BNavbar,
  BNavbarNav,
  BNavbarBrand,
  BNavbarToggle,
  BNavItem,
  BTabs,
  BTab,
  BImg,
  BModal,
  BBreadcrumb,
  BCollapse,
  BEmbed,
  BOverlay
} from "bootstrap-vue";

Vue.use(BVConfigPlugin, {
  BButton: { variant: "primary" }
});

Vue.component("b-embed", BEmbed);
Vue.component("b-overlay", BOverlay);

Vue.component("b-container", BContainer);
Vue.component("b-row", BRow);
Vue.component("b-col", BCol);

Vue.component("b-button", BButton);

Vue.component("b-card", BCard);
Vue.component("b-card-body", BCardBody);
Vue.component("b-card-title", BCardTitle);
Vue.component("b-card-text", BCardText);
Vue.component("b-card-footer", BCardFooter);
Vue.component("b-card-img", BCardImg);

Vue.component("b-form", BForm);
Vue.component("b-form-group", BFormGroup);
Vue.component("b-form-input", BFormInput);
Vue.component("b-input-group", BInputGroup);
Vue.component("b-input-group-append", BInputGroupAppend);
Vue.component("b-form-radio-group", BFormRadioGroup);
Vue.component("b-form-radio", BFormRadio);
Vue.component("b-form-checkbox-group", BFormCheckboxGroup);
Vue.component("b-form-checkbox", BFormCheckbox);
Vue.component("b-form-select", BFormSelect);
Vue.component("b-form-select-option", BFormSelectOption);
Vue.component("b-form-textarea", BFormTextarea);
Vue.component("b-form-invalid-feedback", BFormInvalidFeedback);
Vue.component("b-dropdown", BDropdown);
Vue.component("b-dropdown-item", BDropdownItem);

Vue.component("b-navbar", BNavbar);
Vue.component("b-navbar-nav", BNavbarNav);
Vue.component("b-navbar-brand", BNavbarBrand);
Vue.component("b-navbar-toggle", BNavbarToggle);
Vue.component("b-nav-item", BNavItem);

Vue.component("b-tabs", BTabs);
Vue.component("b-tab", BTab);

Vue.component("b-img", BImg);
Vue.component("b-modal", BModal);
Vue.component("b-breadcrumb", BBreadcrumb);
Vue.component("b-collapse", BCollapse);

// Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
